module.exports = __webpack_public_path__ + "img/customer-service.c1049364.svg";